import NwApp from './src/core/app';
import * as views from './views';
import commons from './views/commons';
import phrases from './res/phrases.json';


const VIEW_DEFAULT = 'page_general';
const app = new NwApp();
app.lang.configure(phrases);
app.router.configure(views, VIEW_DEFAULT, commons);


window.NW = app;
window.Lang = app.lang;


/** WEBPACK FOOTER **
 ** ./assets/scripts/main.js
 **/